enum IQueryKeys {
  processorAllKey = 'processor-all',
  processorInfoKey = 'processor-current',
  merchantInfoKey = 'merchant-current',
  createNovoAccount = 'create-novo-account',
  offersAllKey = 'offers-all',
  offersByIdKey = ' ',
  offersSummaryKey = 'offers-summary',
  offerTEmplatesAllKey = 'offer-templates-all',
  offerTEmplateDetailsKey = 'offer-templates-details',

  leadsAllKey = 'leads-all',
  leadsByIdKey = 'lead-by-id',
  merchantRebateKey = 'merchant-rebate',
  leadsDocuments = 'leads-documents',
  offerSignUrl = 'offer-sign-url',
  currentZohoLead = 'current-zoho-lead',
  notificationAllKey = 'notification-all-key',
  filteredMerchantsKey = 'filtered-merchants-key',
  filteredLeadsKey = 'filtered-leads-key',
  filteredOffersKey = 'filtered-offers-key',
  filteredResubmitsKey = 'filtered-resubmits-key',
  filteredProcessorsKey = 'filtered-processors-key',
  processorsStatsKey = 'processors-stats-key',
  agentsKey = 'agents-key',
  agentLeads = 'agent-leads',
  agentRefName = 'agent-ref-name',
  agentDocuments = 'agent-documents',
  agentLeadDocuments = 'agent-lead-documents',
  agentDashboard = 'agent-dashboard',

  agentPayments = 'agent-payments',

  filteredRebatesKey = 'filtered-rebates-key',
  adminDashboardKey = 'admin-dashboard-key',
}

export enum IProcessorDashboardKeys {
  acceptedOffers = 'dashboard-accepted-offers',
  createdOffers = 'dashboard-created-offers',
  lastLostOffer = 'processor-last-lost-offer',
  merchantLeadsPreferences = 'processor-merchant-leads-preferences',
  merchantsAcceptedOffer = 'processor-merchants-accepted-offer',
}

export default IQueryKeys;
